module.exports = __webpack_public_path__ + "img/maozhua.e30c8d81.gif";